<template>
  <q-card class="fit">
    <q-toolbar
      style="color: black; border-bottom: 1px solid rgba(0, 0, 0, 0.3)"
      class="bg-grey-2"
    >
      <q-btn
        @click="page--"
        padding="xs"
        size="sm"
        icon="arrow_upward"
        :disabled="page == 1 || !numPages"
        flat
      />
      <q-btn
        @click="page++"
        padding="xs"
        size="sm"
        icon="arrow_downward"
        :disabled="page == numPages || !numPages"
        class="q-mr-xs"
        flat
      />
      <q-toolbar-title class="text-body2"
        >{{ numPages ? page : 0 }} /
        {{ numPages ? numPages : 0 }}</q-toolbar-title
      >

      <q-btn
        flat
        dense
        icon="zoom_in"
        class="q-mr-xs"
        @click="setZoom(undefined)"
        :disabled="!numPages"
      />
      <q-separator vertical inset size="1px" class="q-my-md" />
      <q-btn
        flat
        dense
        icon="zoom_out"
        class="q-ml-xs q-mr-md"
        @click="setZoom(undefined, false)"
        :disabled="!numPages"
      />
      <q-btn flat dense icon="close" @click="$emit('close')" />
    </q-toolbar>

    <q-toolbar
      :style="{
        color: 'black',
        borderBottom: '1px solid rgba(0, 0, 0, 0.3)',
        minHeight: '20px',
        height: '20px',
      }"
      class="bg-grey-2 row items-center justify-center"
      v-if="pdfs.length > 1"
    >
      <q-btn
        class="no-border-radius text-left col-5 full-height"
        @click="changePdf(-1)"
        size="10px"
        icon="west"
        :disabled="currentPdf == 0"
        flat
        label="prev pdf"
        padding="0 sm"
      />
      <q-btn
        @click="changePdf(1)"
        size="10px"
        icon-right="east"
        :disabled="currentPdf == pdfs.length - 1"
        class="no-border-radius text-right col-5 full-height"
        flat
        label="next pdf"
        padding="0 sm"
      />
    </q-toolbar>
    <q-card-section
      :style="`height: calc(100% - 50px - ${
        pdfs.length > 1 ? '20px' : '0px'
      }); width: 100%; overflow: auto`"
    >
      <div
        v-if="loadedRatio > 0 && loadedRatio < 1"
        class="bg-primary text-white text-center"
        :style="{ width: loadedRatio * 100 + '%' }"
      >
        {{ Math.floor(loadedRatio * 100) }}%
      </div>
      <div class="row justify-center">
        <div class="col q-ma-sm" id="pdf-container">
          <pdf
            v-if="show"
            id="pdf"
            ref="pdf"
            class="grabbable"
            :style="`width: ${zoom}%`"
            :src="pdfs[currentPdf]"
            :page="page"
            @progress="loadedRatio = $event"
            @error="error"
            @num-pages="numPages = $event"
            @link-clicked="page = $event"
            @loaded="onLoad"
          ></pdf>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import mixin from "../../d-card-mixins";
import pdf from "vue-pdf";
import panzoom from "panzoom";
export default {
  name: "DPdfViewer",
  mixins: [mixin],
  props: {
    componentData: {
      type: Object,
      default: () => {},
    },
    behavior: {
      type: String,
      default: "agent",
    },
  },
  components: {
    pdf,
  },
  data() {
    return {
      show: true,
      loadedRatio: 0,
      numPages: 0,
      lpage: 1,
      lzoom: 100,
      panzoomInstance: null,
      lposition: {},
      lpositionTimeout: null,
      positionTimeout: null,
      pathStore: "componentOverlay.state",
      currentPdf: 0,
    };
  },
  mounted() {
    if (this.behavior === "consumer") {
      // DONT REMOVE THIS WATCHER
      this.$watch("position", (val) => {
        // console.log('MOUNTED WATCHER: ', val)
      });
    }
  },
  methods: {
    onLoad() {
      this.panzoomInstance = panzoom(document.getElementById("pdf"), {
        maxZoom: 4,
        minZoom: 1,
        transformOrigin: { x: -0.1, y: 0.6 },
        beforeWheel: function (e) {
          // allow wheel-zoom only if ctrlKey is down. Otherwise - ignore
          const shouldIgnore = !e.ctrlKey;
          return shouldIgnore;
        },
      });
      this.panzoomInstance.on("pan", (e) => {
        // This event will be called along with events above.
        this.updatePosition();
      });

      this.panzoomInstance.on("zoom", (e) => {
        const currentPosition = this.panzoomInstance.getTransform();
        const currentScale = parseFloat(currentPosition.scale);
        const zoom = parseInt(((currentScale + 0.5) * 100).toFixed(0));
        this.updatePosition();
        this.zoom = currentScale == 1 ? 100 : zoom;
        if (currentScale == 1) {
          this.panzoomInstance.moveTo(0, 0);
          this.updatePosition();
        }
        //console.log("Fired when zoom animation", e);
      });
    },
    updatePosition(debounce = 100, position) {
      clearTimeout(this.positionTimeout);
      this.positionTimeout = setTimeout(() => {
        this.position = position || this.panzoomInstance.getTransform();
      }, debounce);
    },
    setZoom(scale, zoomIn = true) {
      const currentPosition = this.panzoomInstance.getTransform();
      if (currentPosition.scale == 1 && !zoomIn) return;
      if (!scale) {
        scale = zoomIn ? 1.2 : 0.75;
        this.panzoomInstance.zoomTo(0, 0, scale);
      } else {
        this.panzoomInstance.zoomAbs(0, 0, scale);
      }
      const lastPosition = this.panzoomInstance.getTransform();
      this.updatePosition(undefined, lastPosition);
      this.panzoomInstance.moveTo(
        lastPosition.scale !== 1
          ? currentPosition.x - (!zoomIn ? lastPosition.x / 3 : 0)
          : 0,
        0,
      );
    },
    error(err) {
      //console.log("Ups!: ", err);
      this.$emit("close");
    },
    changePdf(pdfIndex) {
      this.currentPdf += pdfIndex;
      this.page = 1;
      this.numPages = 0;
    },
  },
  watch: {
    lposition(val) {
      if (!val || !this.panzoomInstance) return;
      clearTimeout(this.lpositionTimeout);

      this.lpositionTimeout = setTimeout(() => {
        const currentPosition = this.panzoomInstance.getTransform();

        if (JSON.stringify(val) !== JSON.stringify(currentPosition)) {
          if (val.scale !== currentPosition.scale) {
            // console.log("NEW SCALE", val.scale);
            // console.log("CURRENT SCALE", currentPosition.scale);
            const newScale =
              Math.sign(val.scale - currentPosition.scale) == -1
                ? val.scale - currentPosition.scale
                : val.scale;
            // console.log('CALCULATED SCALE: ', newScale)
            this.setZoom(newScale, Math.sign(newScale) == -1 ? false : true);
          }

          if (val.x !== currentPosition.x || val.y !== currentPosition.y) {
            this.panzoomInstance.moveTo(val.x, val.y);
          }
        }
      }, 200);
    },
  },
  computed: {
    zoom: {
      get() {
        if (this.behavior === "agent") {
          return this.lzoom;
        } else {
          const zoom = JSON.parse(
            this.$cardStore.get(`${this.pathStore}`),
          ).zoom;
          return zoom ? zoom : 100;
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lzoom = val;
        } else {
          const state = JSON.parse(this.$cardStore.get(`${this.pathStore}`));
          state.zoom = val;
          this.$cardStore.set(`${this.pathStore}`, JSON.stringify(state));
        }
      },
    },
    page: {
      get() {
        if (this.behavior === "agent") {
          return this.lpage;
        } else {
          const state = JSON.parse(this.$cardStore.get(`${this.pathStore}`));
          return state.page ? state.page : 1;
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lpage = val;
        } else {
          const state = JSON.parse(this.$cardStore.get(`${this.pathStore}`));
          state.page = val;
          this.$cardStore.set(`${this.pathStore}`, JSON.stringify(state));
        }
      },
    },
    position: {
      get() {
        if (this.behavior === "consumer") {
          const position = this.$cardStore
            ? JSON.parse(this.$cardStore.get(`${this.pathStore}`)).position
            : {};

          for (let key in position) {
            if (this.lposition[key] !== position[key]) {
              this.lposition = position;
              // console.log(
              //   "Actualizo mi posicion local: ",
              //   this.lposition.scale
              // );
              return;
            }
          }

          return position ? position : {};
        } else {
          return {};
        }
      },
      set(val) {
        if (this.behavior === "consumer") {
          const state = JSON.parse(this.$cardStore.get(`${this.pathStore}`));
          state.position = val;
          this.$cardStore.set(`${this.pathStore}`, JSON.stringify(state));
        }
      },
    },
    pdfs: {
      get() {
        if (typeof this.componentData.data === "string") {
          return [...new Set(this.componentData.data.split("||"))];
        }

        return [this.componentData.data.url];
      },
    },
  },
};
</script>

<style scoped>
.grabbable {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
/* width */
::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #aaa;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
</style>
